$(document).ready(function() {

	$(".page-id-1068 .cobox").colorbox({
        width:"1080",
        innerWidth:409,
        innerHeight:614,
        //maxWidth:'100%',
        maxHeight:'100%',
        opacity: 0.9,
        speed: 600
    });
    
    $(".page-id-1129 .cobox, .page-id-1173 .cobox, .page-id-1210 .cobox, .page-id-1241 .cobox, .page-id-1281 .cobox, .page-id-1311 .cobox, .page-id-1343 .cobox").colorbox({
        width:"1080",
        innerWidth:300,
        innerHeight:451,
        // maxWidth:'100%',
        maxHeight:'100%',
        opacity: 0.9,
        speed: 600
    });
  
});


var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
$(document).ready(function() {
  $(window).resize(function() {
    if ($(window).width() < 980 || isMobile) {

      console.log('mobile');

      $(".page-id-1129 img, .page-id-1173 img, .page-id-1210 img, .page-id-1241 img, .page-id-1281 img, .page-id-1311 img, .page-id-1343 img, .page-id-1393 img").each(function() {        //Loop through all images

        var $t = $(this);
        ht = "auto";   //If HTML height is defined, add "px" | Else, use "auto"

        $t.css("height", ht);         //Apply the height to the current element

      });

      // handle less than 480
    }else{

      console.log('not mobile');


      $(".page-id-1129 img, .page-id-1173 img, .page-id-1210 img, .page-id-1241 img, .page-id-1281 img, .page-id-1311 img, .page-id-1343 img, .page-id-1393 img").each(function() {        //Loop through all images
        var $t = $(this);             //$t is the current iteration
        var ht = $t.attr("height");   //Get the HTML height
        ht = ht ? ht+"px" : "auto";   //If HTML height is defined, add "px" | Else, use "auto"
        $t.css("height", ht);         //Apply the height to the current element
      });

      //handle else
    }
  });
});